import { render, staticRenderFns } from "./QualityAlertsView.vue?vue&type=template&id=0121a28b&scoped=true"
import script from "./QualityAlertsView.vue?vue&type=script&lang=js"
export * from "./QualityAlertsView.vue?vue&type=script&lang=js"
import style0 from "./QualityAlertsView.vue?vue&type=style&index=0&id=0121a28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0121a28b",
  null
  
)

export default component.exports